import { render, staticRenderFns } from "./Plandetail.vue?vue&type=template&id=d684fcca&scoped=true"
import script from "./Plandetail.vue?vue&type=script&lang=js"
export * from "./Plandetail.vue?vue&type=script&lang=js"
import style1 from "./Plandetail.vue?vue&type=style&index=1&id=d684fcca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d684fcca",
  null
  
)

export default component.exports